import { Maybe } from 'graphql/jsutils/Maybe'
import styled from 'styled-components'

import SanityLink from '../../global/SanityLink'

export const Container = styled.div<{ backgroundColor?: Maybe<string>; textColor?: Maybe<string> }>`
  display: flex;
  position: relative;
  width: 100%;
  padding: 12px 24px;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor ?? theme.colors.semantic.informational};
  color: ${({ theme, textColor }) => textColor ?? theme.colors.grayscale.white};
`

export const Wrapper = styled.div`
  display: flex;
  max-width: 1440px;
  width: 100%;
  height: 100%;
  gap: 24px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  color: inherit;
  background: inherit;
  line-height: 1.24;
`

export const Text = styled.p`
  display: inline-flex;
  margin: 0;
`

export const Link = styled(SanityLink)<{ textColor?: Maybe<string> }>`
  color: ${({ theme, textColor }) => textColor ?? theme.colors.grayscale.white};
  font-weight: 700;
  font-size: inherit;
`

export const CloseButton = styled.button<{ textColor?: Maybe<string> }>`
  display: flex;
  position: absolute;
  cursor: pointer;
  color: ${({ theme, textColor }) => textColor ?? theme.colors.grayscale.white};
  right: 0;
  background: transparent;
  border: none;
  align-items: center;
  justify-content: center;
`
